import { ASSETS } from './registry'
import type { AssetConfig } from './types'

/**
 * Registry of every asset that has a /markets/<slug> page. Slug is the
 * asset's CoinGecko id (e.g. "bitcoin", "ethereum", "solana", "usd-coin").
 * The dynamic route /markets/[asset]/page.tsx looks the asset up by slug.
 *
 * Order here is the default order shown in the asset switcher dropdown
 * before market-cap data is fetched. Bitcoin first since it's the
 * canonical asset for this app; rest by historical market-cap rank.
 */
export { ASSETS }

/** URL slug used under /markets/. Currently the same as the CoinGecko id. */
export function assetSlug(asset: AssetConfig): string {
	return asset.coingeckoId
}

/** Lookup an asset by its slug (coingeckoId). */
export function findAssetBySlug(slug: string): AssetConfig | undefined {
	return ASSETS.find((a) => a.coingeckoId === slug)
}
